module.exports = __webpack_public_path__ + "static/media/home-bg-mobile-low.a099ce78.jpg";